(function ($) {
	$.fn.lmDriverSearch = function(options) {
		// NOTE: Don't run logic below if nothing is in the dom
		if (!this.length) {
			return false;
		}
		
		// Default settings are set here
		var settings = $.extend({
			selector: 'driver-search',
			series_id: '',
			term_id: ''
		}, options);
		
		// These are all the methods available for the plugin
		var	methods = {},
			$dsInput,
			$dsLink,
			$dsList,
			drivers = [],
			feed = '',
			searched,
			regex;

		methods.search = function(str) {
			searched = "";

			// If the search string has at least 3 characters
			if (str.length > 2) {
				// Loop through the drivers list
				for (var i = 0; i<drivers.length; ++i) {
					// Set up a new regex
					regex = new RegExp(str, 'i');
					// If there is a match add the driver to the dropdown
					if (drivers[i].name.match(regex)) {
						searched += '<li class="driver-search__list-item"><a href="'+drivers[i].url+'">'+drivers[i].name+'</a></li>';
					}
				}
			}
			$dsList.html(searched);
		}

		methods.getDrivers = function() {
			$.ajax({
				url: feed,
				data: {
					series_id: settings.series_id,
					term_id: settings.term_id
				},
				dataType: 'json',
				error: function(jqXHR, textStatus, errorThrown) {
					drivers = [];
				},
				success: function(data, textStatus, jqXHR) {
					drivers = data;
				}
			});
		}
		
		methods.events = function($context) {
			// On keyup on the search box, run the test function
			$dsInput.off('keyup.lmDriverSearch').on('keyup.lmDriverSearch', function(event) {
				event.preventDefault();
				event.stopPropagation();
				methods.search($(this).val());
			});

			// When the user clicks anywhere else on the page, clear the results box
			$('body').off('click.lmDriverSearch').on('click.lmDriverSearch', function(event) {
				$dsList.html("");
			});
		}

		methods.initContext = function($context) {
			$dsInput = $('.' + settings.selector + '__input');
			$dsLink = $('.' + settings.selector + '__list a');
			$dsList = $('.' + settings.selector + '__list');

			if ($context.attr('data-feed')) {
				feed = $context.data('feed');
			}

			methods.getDrivers();
			methods.events($context);
		}
		
		methods.initContext(this);

		return this;
	};
}(jQuery));
